export const SITE_TEMPLATES = {
  AUTH_TOKEN: "{{AUTH_TOKEN}}",

  IS_NEW_USER: "{{IS_NEW_USER}}",
} as const;

export type SiteTemplateKey = keyof typeof SITE_TEMPLATES;
/**
 * парсит строку вида: if(!!{{AUTH_TOKEN}} && {{IS_NEW_USER}}) {return true} else return false
 * в if(!!12344 && false) {return true} else return false
 */
export const parseConditionTemplate = (
  template: string,
  params: Record<SiteTemplateKey, string>,
): string => {
  return Object.keys(SITE_TEMPLATES).reduce(
    (result, key) =>
      result.replaceAll(
        SITE_TEMPLATES[key as SiteTemplateKey],
        params[key as SiteTemplateKey],
      ),
    template,
  );
};
